import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, ControlWrapper } from '../../../../../../../components';
import { useChannel } from '../../../../../components/channel/hooks/use-channel';
import { useGate } from '../../../../../hooks/gate';
import { ChannelType } from '../../../../../types';
import { ChannelGateType } from '../../../../../types/channel/gate';
import { useGateSupportedFeatures } from '../../hooks/use-gate-supported';
import { AdditionalModes } from '../additional-modes';
import { GateCalibrationInfo } from '../calibration-info/calibration-info';
import { GateKindsControl } from './kinds';

type GateStepByStepProps = {
  channel: ChannelType;
};

export const GateStepByStep: React.FC<GateStepByStepProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const [quickControl, setQuickControl] = useState<boolean>(false);
  const { calibrationNeeded } = useChannel({ channel });
  const { handleStepByStep, handleQuickControl } = useGate(channel);
  const { stepByStepSupported } = useGateSupportedFeatures(channel);
  const channelData = channel.data as ChannelGateType;
  const gateKind = channelData.gateKind;

  useEffect(() => {
    if (channelData) setQuickControl(channelData.isQuickControl);
  }, [channelData.isQuickControl]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuickControl(e.target.checked);
    handleQuickControl(e.target.checked);
  };

  const handleAction = () => handleStepByStep();

  return (
    <>
      <ControlWrapper>
        <div>
          {stepByStepSupported && (
            <GateKindsControl gateKind={gateKind} channel={channel} handleAction={handleAction} />
          )}
          <AdditionalModes channel={channel} />
        </div>
      </ControlWrapper>
      <div className="p-l-24 p-r-24 m-t-24">
        <Checkbox checked={quickControl} onChange={handleChange} reverse>
          <p style={{ fontSize: 16, marginLeft: 12 }}>{t('quickControl')}</p>
        </Checkbox>
      </div>
      {calibrationNeeded && <GateCalibrationInfo channel={channel} />}
    </>
  );
};
